import React, { useEffect, useState, } from 'react';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, TextAlignTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import { FlatList, Modal, Platform, StyleSheet, Switch, TouchableOpacity, View, } from 'react-native';
import { HeaderCtaBase } from '../../header/HeaderCta.base';
import { Icon } from '../../icon/Icon';
import { Typography } from '../../typography/Typography';
import BoilerPlate from '../boilerPlate/BoilerPlate';
import { Button } from '../../button/Button';
import AsyncStorage from '@react-native-async-storage/async-storage';
import RNBiometrics from 'react-native-simple-biometrics';
import { Divider } from '../../divider/Divider';
const MyProfile = ({ userName, rightItem, headerAction, triggerAction, height, accountDetailsAction, myLoanDetailsAction, faqsAction, contactUsAction, loanClosureAction, trackForeclosureRequestAction, aboutUsAction, biometricAuthenticationAction, isLoanRenewalInProgress, showLoanDetails, shouldShowContactUs, showForeclosure, isLoanExpired, showLogout, filteredList, onLogoutAction, biometricsPermissionFromFirebase, }) => {
    const [showBiometricDisableCard, setShowBiometricDisableCard,] = useState(false);
    const [filteredProfileList, setFilteredProfileList,] = useState(filteredList);
    const [showBiometricCancelledCard, setShowBiometricCancelledCard,] = useState(false);
    const [userBiometricSuccess, setUserBiometricSuccess,] = useState(true);
    const [isbiometricsEnabled, setBiometricsEnabled] = useState(false);
    const [showBiometricOption, setShowBiometricOption] = useState(false);
    useEffect(() => {
        const showBiometricPermissionOnTheList = async () => {
            try {
                const canAuthenticate = await RNBiometrics.canAuthenticate();
                if (canAuthenticate && Platform.OS !== "web" && biometricsPermissionFromFirebase) {
                    setShowBiometricOption(true);
                    // Wait for AsyncStorage retrieval
                    const storedPermission = await AsyncStorage.getItem("biometric_permission");
                    if (storedPermission === "true") {
                        setBiometricsEnabled(true);
                    }
                    else {
                        setBiometricsEnabled(false);
                    }
                }
                else {
                    setShowBiometricOption(false);
                }
            }
            catch (error) {
            }
        };
        showBiometricPermissionOnTheList();
    }, []);
    const biometricAuthentication = async () => {
        const accessToken = await AsyncStorage.getItem('access_token');
        setUserBiometricSuccess(false);
        if (accessToken !== null &&
            accessToken !== undefined) {
            await RNBiometrics.canAuthenticate()
                .then(async (res) => {
                if (res) {
                    setShowBiometricCancelledCard(false);
                    try {
                        await RNBiometrics.requestBioAuth('Authenticate to enter Volt App', 'Please complete biometric authentication')
                            .then(async (result) => {
                            setUserBiometricSuccess(true);
                            await AsyncStorage.setItem("biometric_permission", "true");
                        })
                            .catch(async (error) => {
                            //@ts-ignore
                            if (error
                                .toString()
                                .includes('Authentication canceled') ||
                                error
                                    .toString()
                                    .includes('Authentication cancelled')) {
                                setShowBiometricCancelledCard(true);
                                setUserBiometricSuccess(false);
                                await AsyncStorage.setItem("biometric_permission", "false");
                            }
                        });
                    }
                    catch (error) {
                        //@ts-ignore
                        if (error
                            .toString()
                            .includes('Authentication canceled')) {
                            setShowBiometricCancelledCard(true);
                            setUserBiometricSuccess(false);
                            await AsyncStorage.setItem("biometric_permission", "false");
                        }
                    }
                }
                else {
                }
            })
                .catch((error) => {
                //@ts-ignore
            });
        }
    };
    const renderDivider = () => {
        return (React.createElement(View, { style: { paddingHorizontal: 16 } },
            React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Milk_1 })));
    };
    const renderMenuList = () => {
        return (React.createElement(View, { style: { marginTop: 8 } },
            React.createElement(FlatList, { data: filteredProfileList, renderItem: ({ item }) => renderIndividualListItem(item), ItemSeparatorComponent: renderDivider }),
            showBiometricOption && renderBiometricPermission()));
    };
    const renderBiometricAuthenticationCancelled = () => {
        return (React.createElement(Modal, { visible: true, transparent: true, animationType: 'slide' },
            React.createElement(View, { style: {
                    flex: 1,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    justifyContent: 'flex-end',
                } },
                React.createElement(View, { style: {
                        paddingHorizontal: 16,
                        paddingVertical: 24,
                        backgroundColor: 'white',
                        padding: 30,
                        alignItems: 'center',
                        alignContent: 'center',
                        borderTopLeftRadius: 16,
                        borderTopRightRadius: 16,
                        width: '100%',
                    } },
                    React.createElement(Icon, { name: IconTokens.SystemError, size: IconSizeTokens.XXL }),
                    React.createElement(View, { style: {
                            marginTop: 12,
                            marginBottom: 12,
                        } },
                        React.createElement(View, { style: {
                                alignItems: 'center',
                                alignSelf: 'center',
                                alignContent: 'center',
                                marginBottom: 12,
                            } }),
                        React.createElement(Typography, { label: 'You have biometrics enabled', fontSize: FontSizeTokens.XXL, fontFamily: FontFamilyTokens.Inter, textAlign: TextAlignTokens.center, lineHeight: 28, fontWeight: '600', color: ColorTokens.Grey_Night })),
                    React.createElement(Typography, { label: 'Kindly authorise with your biometric setup so we can safely let you in the app.', fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, textAlign: TextAlignTokens.center, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Charcoal }),
                    React.createElement(View, { style: {
                            marginTop: 36,
                            marginBottom: 20,
                            width: '100%',
                        } },
                        React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, label: 'Authenticate now', 
                            //@ts-ignore
                            fontSize: 14, width: ButtonWidthTypeToken.FULL, onPress: async () => {
                                setShowBiometricCancelledCard(false);
                                await biometricAuthentication();
                            } }))))));
    };
    const renderBiometricPermission = () => {
        return (React.createElement(React.Fragment, null,
            renderDivider(),
            React.createElement(TouchableOpacity, { style: {
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    padding: 16,
                    alignItems: 'center',
                    alignContent: 'center',
                }, activeOpacity: 1, onPress: async () => { } },
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        alignSelf: 'center',
                        alignContent: 'center',
                        alignItems: 'center',
                    } },
                    React.createElement(View, { style: {
                            borderRadius: 120,
                            backgroundColor: '#F3F5FC',
                            width: 40,
                            height: 40,
                            alignItems: 'center',
                            alignContent: 'center',
                            justifyContent: 'center',
                        } },
                        React.createElement(Icon, { name: IconTokens.BIOMETRIC_PERMISSION, size: IconSizeTokens.XXL, color: ColorTokens.Primary_100 })),
                    React.createElement(View, { style: { marginLeft: 12 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, label: 'Enable biometric security', color: ColorTokens.Grey_Night }))),
                React.createElement(View, null,
                    React.createElement(Switch, { value: isbiometricsEnabled, thumbColor: isbiometricsEnabled ? '#1434CB' : '#FFFFFF', trackColor: { true: '#1434CB33', false: '#98A2B3' }, onValueChange: async (result) => {
                            if (result) {
                                await biometricAuthentication();
                            }
                            else {
                                await AsyncStorage.setItem("biometric_permission", "false");
                            }
                            setBiometricsEnabled(!isbiometricsEnabled);
                        } })))));
    };
    const renderIndividualListItem = (item) => {
        return (React.createElement(TouchableOpacity, { style: {
                flexDirection: 'row',
                justifyContent: 'space-between',
                padding: 16,
                alignItems: 'center',
                alignContent: 'center',
            }, activeOpacity: 1, onPress: async () => {
                await triggerAction(item.action);
            } },
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    alignSelf: 'center',
                    alignContent: 'center',
                    alignItems: 'center',
                } },
                React.createElement(View, { style: {
                        borderRadius: 120,
                        backgroundColor: '#F3F5FC',
                        width: 40,
                        height: 40,
                        alignItems: 'center',
                        alignContent: 'center',
                        justifyContent: 'center',
                    } },
                    React.createElement(Icon, { name: item.iconName, size: IconSizeTokens.XXL, color: item.iconColor })),
                React.createElement(View, { style: { marginLeft: 12 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, label: item.title, color: ColorTokens.Grey_Night }))),
            React.createElement(View, null,
                React.createElement(Icon, { name: IconTokens.ChervonDownRight, size: IconSizeTokens.XXL, color: ColorTokens.Grey_Night }))));
    };
    const renderHeader = () => {
        return (React.createElement(View, { style: {
                marginTop: Platform.OS === 'ios' ? 20 : 0,
            } },
            React.createElement(HeaderCtaBase, { title: userName, rightItem: rightItem, action: headerAction, shouldShowShadow: false, isBackButton: false, leftIcon: {
                    id: 'bt_profileScreen_goBack',
                    name: IconTokens.Cross,
                    size: IconSizeTokens.XXL,
                    color: ColorTokens.Grey_Charcoal,
                }, triggerAction: triggerAction })));
    };
    const renderFooter = () => {
        return (React.createElement(TouchableOpacity, { style: {
                flexDirection: 'row',
                padding: 16,
                alignItems: 'center',
                alignContent: 'center',
            }, activeOpacity: 1, onPress: () => {
                triggerAction(onLogoutAction);
            } },
            React.createElement(View, { style: {
                    borderRadius: 120,
                    backgroundColor: '#F3F5FC',
                    width: 40,
                    height: 40,
                    alignItems: 'center',
                    alignContent: 'center',
                    justifyContent: 'center',
                } },
                React.createElement(Icon, { name: IconTokens.Logout_Profile, size: IconSizeTokens.XXL, color: ColorTokens.Primary_100 })),
            React.createElement(View, { style: { marginLeft: 12 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Primary_100, label: 'Logout' }))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(BoilerPlate, { height: height, headerChild: renderHeader(), bottomChildren: showLogout && renderFooter() },
            renderMenuList(),
            showBiometricCancelledCard &&
                renderBiometricAuthenticationCancelled()),
        !userBiometricSuccess &&
            React.createElement(View, { style: {
                    position: 'absolute',
                    width: '100%',
                    height: height,
                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                    zIndex: 99,
                    ...StyleSheet.absoluteFillObject
                } })));
};
export default MyProfile;
